import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps } from "antd";
import TextArea from "antd/es/input/TextArea";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";

type Props = {} & FormItemProps<SaveTicketValues>;

export const DescriptionInput = observer((props: Props) => {
  const t = useTranslation();

  const config = useFieldConfig("description");

  if (config && config.hidden) return <></>;

  const placeholder =
    config?.placeholder === "-"
      ? ""
      : config?.placeholder ||
        t("maintenance:ticket.create.description.placeholder");

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.description.label");

  return (
    <Form.Item<SaveTicketValues>
      name="description"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.description.error.empty"),
        },
      ]}
      {...props}
    >
      <TextArea placeholder={placeholder} />
    </Form.Item>
  );
});
